import React, { useEffect, useState } from 'react';
import { HotelDetailsTab } from './components/hotel-edit-tabs/HotelDetails';
import { useDispatch } from 'react-redux';
import { ENetworkRequestStatus, IHotel, makeBackendApi } from 'services/BackendApi';
import { Link } from 'ui/Link';
import { enqueueNotification } from 'store/modules/ui';
import { produce } from 'immer';
import * as _ from 'lodash-es';

export const Create = () => {
  const [filtersCategories, setFiltersCategories] = useState<any[]>([]);
  const [starRatings, setStarRatings] = useState<string[]>([]);
  const [draftHotel, setDraftHotel] = useState<Partial<IHotel>>({
    name: '',
    description: '',
    countryCode: '',
    region: '',
    starRating: '',
    defaultCurrency: 'USD',
    preferred: false,
    amenities: [],
    highlights: [],
    overview: [],
    policiesAndRestrictions: [],
    filters: [],
    hotelId: '',
    enabled: true,
    disabledForTa: false,
    externalSystem: null,
    externalHotelId: '',
    externalSupplierId: '',
    externalCurrency: null,
    externalCurrencyExchangeRate: null,
    uploads: [],
  });

  const backendApi = makeBackendApi();
  const [createHotelRequest, setCreateHotelRequest] = useState(ENetworkRequestStatus.IDLE);

  const dispatch = useDispatch();
  useEffect(() => {
    backendApi.hotelAdminGetOptions().then(res => {
      setFiltersCategories(res.data.data.filtersCategories.map(fc => fc.filters).flat());
      setStarRatings(res.data.data.starRatings);
    });
  }, []);

  return (
    <div className="container w-1280px mx-auto">
      <Link className="font-pt-sans" to="/hotel-admin">
        Back to Hotels
      </Link>
      <h1 className="font-normal font-noe-display text-[36px] leading-46px">
        Products - <span className="text-[26px]">Hotels - Creating new hotel</span>
      </h1>
      <HotelDetailsTab
        hotel={draftHotel}
        onUpdate={(field, val) => {
          setDraftHotel({
            ...produce(draftHotel, _draftHotel => {
              _.set(_draftHotel, field, val);

              if (field === 'countryCode') {
                _.set(_draftHotel, 'region', '');
              }
            }),
          });
        }}
        filtersCategories={filtersCategories}
        starRatings={starRatings}
        onCta={async () => {
          setCreateHotelRequest(ENetworkRequestStatus.PENDING);
          try {
            // get a hotel with the matching hotelID
            const hotelByIdRes = await backendApi.getHotelByHotelId(draftHotel.hotelId!);
            // @ts-ignore
            const hotelById = hotelByIdRes.data.data?.[0];
            if (hotelById) {
              dispatch(
                enqueueNotification({
                  message: 'Error creating hotel: a hotel with this hotelId already exists',
                  options: { variant: 'warning' },
                })
              );
              setCreateHotelRequest(ENetworkRequestStatus.ERROR);
              return;
            }

            const newHotel = await backendApi.hotelAdminPostHotel(draftHotel);
            setCreateHotelRequest(ENetworkRequestStatus.SUCCESS);
            dispatch(
              enqueueNotification({
                message: `Hotel created successfully`,
                options: { variant: 'success' },
              })
            );
            window.location.href = `/hotel-admin/${newHotel.data.data.uuid}/edit`;
          } catch (error) {
            setCreateHotelRequest(ENetworkRequestStatus.ERROR);
            dispatch(
              enqueueNotification({
                message: 'Error creating hotel',
                options: { variant: 'error' },
              })
            );
          }
        }}
        networkRequest={createHotelRequest}
        setFeaturedPhoto={() => {}}
        deleteUpload={() => {}}
        ctaLabel="Create Hotel"
        mode="create"
      />
    </div>
  );
};
